var map = {
	"./goldcoin/index-btn-frens.png": 64028,
	"./memetown/index-btn-frens.png": 67884,
	"./reflection/index-btn-frens.png": 88482,
	"./tapcoin/index-btn-frens.png": 94744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52858;